export default "__VITE_ASSET__CHz0KOaG__"